import React from 'react'
import { connect } from 'react-redux'
import * as modals from 'constants/modal_types'
import { selectCurrentTicketLabels } from 'selectors/tickets'
import { selectDeviceTypeIsMobile } from 'selectors/app'
import { doShowModal } from 'actions/modals'
import { doFetchTopLabelsForCurrentMailbox } from 'actions/labels'
import DesktopLabelList from './Desktop'
import MobileLabelList from './Mobile'

const select = state => ({
  labels: selectCurrentTicketLabels(state),
  deviceTypeIsMobile: selectDeviceTypeIsMobile(state),
})

const perform = dispatch => ({
  enterEditingState: (selectedLabel, { top, left } = {}) => {
    dispatch(doFetchTopLabelsForCurrentMailbox())
    dispatch(doShowModal(modals.LABEL_FORM, { selectedLabel, top, left }))
  },
})

const LabelList = ({ deviceTypeIsMobile, ...rest }) => {
  if (!deviceTypeIsMobile) return <DesktopLabelList {...rest} />

  return <MobileLabelList {...rest} />
}

export default connect(select, perform)(LabelList)
